/* istanbul ignore file */
export * from './InstallmentCard';
